import { AlertBye } from "./AlertBye";
import "./alertBye.css";

export default AlertBye;
